import { authorizedFetch as fetchGET, fetchPOST, fetchPUT, fetchDELETE } from '@/helpers/authFetch';
import { administrationEndpoint, checkServiceOK } from './serviceConstants';

const getPlants = () => (fetchGET(`${administrationEndpoint}/plants`).then(checkServiceOK));

const deletePlant = (plants) => (
  fetchDELETE(`${administrationEndpoint}/plants`, plants)
    .then((res) => checkServiceOK(res, true))
);

const createPlant = (data) => (
  fetchPOST(`${administrationEndpoint}/plants`, data)
    .then((res) => checkServiceOK(res, true))
);

const editPlant = (wkzNumber, data) => (
  fetchPUT(`${administrationEndpoint}/plants/${wkzNumber}`, data)
    .then((res) => checkServiceOK(res, true))
);

const createModelSeries = (data) => (
  fetchPOST(`${administrationEndpoint}/model-series/list`, data)
    .then((res) => checkServiceOK(res, true))
);

const deleteModelSeries = (data) => (
  fetchDELETE(`${administrationEndpoint}/model-series`, data)
    .then((res) => checkServiceOK(res, true))
);

const getModelSeries = () => (fetchGET(`${administrationEndpoint}/model-series`).then(checkServiceOK));

const editModelSeries = (data) => (
  fetchPUT(`${administrationEndpoint}/model-series/list`, data)
    .then((res) => checkServiceOK(res, true))
);

const activeModelSerieForEfa = (data) => (
  fetchPUT(`${administrationEndpoint}/model-series/active-efa`, data)
    .then((res) => checkServiceOK(res, true))
);

const saveHelp = (data, tab) => (
  fetchPUT(`${administrationEndpoint}/helps/${tab}`, data)
    .then((res) => checkServiceOK(res, true))
);

const getHelp = (tab) => (
  fetchGET(`${administrationEndpoint}/helps/${tab}`).then(checkServiceOK)
);

const getNewsfeed = () => (fetchGET(`${administrationEndpoint}/news/list`).then(checkServiceOK));

const createNewsfeed = (data) => (
  fetchPOST(`${administrationEndpoint}/news`, data)
    .then((res) => checkServiceOK(res, true))
);
const editNewsfeed = (data) => (
  fetchPUT(`${administrationEndpoint}/news`, data)
    .then((res) => checkServiceOK(res, true))
);
const deleteNewsfeed = (data) => (
  fetchDELETE(`${administrationEndpoint}/news`, data)
    .then((res) => checkServiceOK(res, true))
);

const getFieldMaintenanceTabForms = (tabCode) => (
  fetchGET(`${administrationEndpoint}/forms/${tabCode}`).then(checkServiceOK)
);

const saveFieldMaintenanceTabForms = (tabCode, data) => (
  fetchPOST(`${administrationEndpoint}/forms/${tabCode}`, data)
    .then((res) => checkServiceOK(res, true))
);

const getLastForms = (form) => (
  fetchGET(`${administrationEndpoint}/forms/${form}`).then(checkServiceOK)
);

const getPlantsByList = (plantsIds) => (
  fetchGET(`${administrationEndpoint}/plants/list/${plantsIds?.join(',')}`).then(checkServiceOK)
);

const getProductGroups = () => fetchGET(`${administrationEndpoint}/product-group/not-mgc`).then(checkServiceOK);

const getProductGroupsMGC = () => fetchGET(`${administrationEndpoint}/product-group/mgc`).then(checkServiceOK);

const createProductGroup = (newProductGroup) => (
  fetchPOST(`${administrationEndpoint}/product-group`, newProductGroup)
    .then((res) => checkServiceOK(res, true))
);

const editProductGroup = (productGroupId, productGroup, isMGC) => (
  fetchPUT(`${administrationEndpoint}/product-group/${productGroupId}/${isMGC ? 'mgc' : 'not-mgc'}`, productGroup)
    .then((res) => checkServiceOK(res, true))
);

const editProductGroupCross = (productGroupId, productGroup) => (
  fetchPUT(`${administrationEndpoint}/product-group/${productGroupId}/cross-plants`, productGroup)
    .then((res) => checkServiceOK(res, true))
);

const getSUMSCriteria = () => fetchGET(`${administrationEndpoint}/sums-criteria`).then(checkServiceOK);

const editCriteria = (criteriaNumber, criteria) => (
  fetchPUT(`${administrationEndpoint}/sums-criteria/${criteriaNumber}`, criteria)
    .then((res) => checkServiceOK(res, true))
);
const createSUMSCriteria = (newCriteria) => (
  fetchPOST(`${administrationEndpoint}/sums-criteria`, newCriteria)
    .then((res) => checkServiceOK(res, true))
);
const deleteSUMSCriteria = (listOfCriterias) => (
  fetchDELETE(`${administrationEndpoint}/sums-criteria`, listOfCriterias)
    .then((res) => checkServiceOK(res, true))
);

const getCriteriaByEFANumber = (signal, efaNumber) => (
  fetchGET(`${administrationEndpoint}/sums-criteria/${efaNumber}`, { signal }).then(checkServiceOK)
);

const getProductGroupsCross = () => (
  fetchGET(`${administrationEndpoint}/product-group/cross-plants`).then(checkServiceOK)
);

const getParamsConfiguration = (signal) => (
  fetchGET(`${administrationEndpoint}/parameter`, { signal }).then(checkServiceOK)
);

const saveParameter = (signal, paramKey, data) => (
  fetchPUT(`${administrationEndpoint}/parameter/${paramKey}`, data, signal)
    .then((res) => checkServiceOK(res, true))
);

const getParameterConfiguration = (signal, paramKey) => (
  fetchGET(`${administrationEndpoint}/parameter/${paramKey}`, { signal }).then(checkServiceOK)
);

const getWorflowStatusDuration = (signal) => (
  fetchGET(`${administrationEndpoint}/workflow-status-duration`, { signal }).then(checkServiceOK)
);

const saveWorkflowStatusDuration = (status, duration) => (
  fetchPUT(`${administrationEndpoint}/workflow-status-duration/${status}`, { durationDays: duration })
    .then((res) => checkServiceOK(res, true))
);

export default {
  getPlants,
  deletePlant,
  createPlant,
  editPlant,
  createModelSeries,
  deleteModelSeries,
  getModelSeries,
  editModelSeries,
  activeModelSerieForEfa,
  saveHelp,
  getHelp,
  createNewsfeed,
  getNewsfeed,
  editNewsfeed,
  deleteNewsfeed,
  getFieldMaintenanceTabForms,
  saveFieldMaintenanceTabForms,
  getLastForms,
  getPlantsByList,
  getProductGroups,
  getProductGroupsMGC,
  createProductGroup,
  editProductGroup,
  getSUMSCriteria,
  editCriteria,
  createSUMSCriteria,
  deleteSUMSCriteria,
  getCriteriaByEFANumber,
  getProductGroupsCross,
  editProductGroupCross,
  getParamsConfiguration,
  saveParameter,
  getParameterConfiguration,
  getWorflowStatusDuration,
  saveWorkflowStatusDuration,
};
